import MuxPlayer, { MuxPlayerProps } from '@mux/mux-player-react';
import clsx from 'clsx';

import styles from './HeroVideo.module.scss';

interface Props {
  video: {
    mobile?: {
      playbackId: string;
      cover: string;
    };
    desktop?: {
      playbackId: string;
      cover: string;
    };
  };
  className?: string;
}

export default function HeroVideo({ video, className }: Props) {
  const videoOptions: MuxPlayerProps = {
    autoPlay: true,
    loop: true,
    muted: true,
    style: {
      // @ts-expect-error - MuxPlayer variable
      '--controls': 'none',
      '--media-object-fit': 'cover',
      '--media-poster-image-background-size': 'cover',
    },
  };

  if (!video.desktop || !video.mobile) {
    return null;
  }

  return (
    <div className={className}>
      <MuxPlayer
        playbackId={video.desktop.playbackId}
        className={clsx(styles.video, styles.desktop)}
        poster={video.desktop.cover}
        {...videoOptions}
      />

      <MuxPlayer
        playbackId={video.mobile.playbackId}
        className={clsx(styles.video, styles.mobile)}
        poster={video.mobile.cover}
        {...videoOptions}
      />
    </div>
  );
}
